import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldWarning, Check, Flag, CaretRight, Phone } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SuspiciousCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSuspicious();
  }, []);

  const fetchSuspicious = async () => {
    try {
      const response = await axios.get(`${API}/admin/customers/suspicious`);
      setCustomers(response.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleResolve = async (id) => {
    try {
      await axios.post(`${API}/admin/customers/${id}/resolve-suspicion`);
      toast.success('Suspicion resolved successfully');
      fetchSuspicious();
    } catch (err) {
      toast.error('Failed to update status');
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center gap-3 mb-6 border-b pb-3">
        <ShieldWarning size={28} className="text-red-500" />
        <div>
          <h2 className="text-xl font-bold text-gray-800">Suspicious Customers List</h2>
          <p className="text-sm text-gray-500">View and manage customers flagged for suspicious activity</p>
        </div>
      </div>

      {loading ? (
        <p className="text-gray-500 text-center py-6">Loading suspicious clients...</p>
      ) : customers.length === 0 ? (
        <p className="text-gray-400 text-center py-8">No customers currently flagged as suspicious</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {customers.map((c) => {
            const initial = (c.username || c.phone || '?').charAt(0).toUpperCase();
            return (
              <div 
                key={c.id} 
                onClick={() => {
                  if (c.room_id) navigate(`/admin-chat/${c.room_id}`);
                }}
                className="flex items-center justify-between p-3 border border-gray-200 border-l-4 border-l-red-500 rounded-lg hover:bg-gray-50 bg-white transition-colors cursor-pointer shadow-sm relative group"
              >
                <div className="flex items-center gap-3 overflow-hidden">
                  <div className="w-9 h-9 rounded-full bg-red-500 text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
                    {initial}
                  </div>
                  <div className="overflow-hidden">
                    <h3 className="font-bold text-[13px] text-gray-800 truncate leading-tight mb-0.5">
                      {c.username || c.phone}
                    </h3>
                    <p className="text-[11px] text-gray-500 flex items-center gap-1">
                      <span>{c.mb_setup || ''} - - - </span>
                      <Phone size={12} weight="fill" className="text-pink-600 flex-shrink-0" />
                      <span className="truncate">{c.phone || 'N/A'}</span>
                    </p>
                    {c.flag_reason && (
                       <p className="text-[10px] text-red-500 truncate font-medium mt-0.5">Reason: {c.flag_reason}</p>
                    )}
                  </div>
                </div>
                <div className="flex-shrink-0 ml-2">
                  <CaretRight size={16} className="text-gray-400 group-hover:text-gray-600" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
